module.exports = ".mat-radio-label-content {\r\n  font-weight: normal !important;\r\n}"